<template>
    <div>
        <h1>Detalle de Indicador</h1>
        <div>ID del Indicador: {{ $route.params.idindicador }}</div>
        <div>Encriptado: {{ encryptedIdIndicador }}</div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import store from "../../stores/index.js";
export default {
    name: "detalleindicadorsalto",
    data() {
        return {
            encryptedIdIndicador: ''
        };
    },
    methods: {
        encryptIdIndicador() {                        
            let global = JSON.parse(unescape(process.env.PACKAGE_JSON)).global;
            let env = global[global.env];
            this.$aes.setKey(env.path.secret);
            let cifra = this.$aes.encrypt(this.$route.params.idindicador.toString());
            let temporal = Math.random().toString(36).substring(2, 6) + cifra + Math.random().toString(36).substring(2, 6);
            let encrypted = this.$aes.encrypt(temporal);
            encrypted = encrypted.replace(/\//g, "AbcYq");
            encrypted = encrypted.replace(/\+/g, "qYcbA");
            this.encryptedIdIndicador = encrypted;
            console.log('Encrypted ID:', this.encryptedIdIndicador); // Agrega este log
            this.$router.push("/detalleindicador/" + encrypted);
        },
    },
    created() {
        this.encryptIdIndicador();
        console.log('Created hook called'); // Agrega este log
    }
};
</script>

<style scoped>
/* Add your styles here */
</style>